import { render, staticRenderFns } from "./TheAllCommentsTable.vue?vue&type=template&id=4e5ddef8"
import script from "./TheAllCommentsTable.vue?vue&type=script&lang=js"
export * from "./TheAllCommentsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports